import {
  IChoiceGroupOption,
  IChoiceGroupOptionStyleProps,
  IChoiceGroupOptionStyles,
  IChoiceGroupStyles,
} from '@fluentui/react';

export const choiceGroupStyles: IChoiceGroupStyles = {
  label: {
    display: 'inline',
  },
  flexContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    gap: 16,
  },
};

export const optionStyle = (
  props: IChoiceGroupOptionStyleProps
): Partial<IChoiceGroupOptionStyles> => ({
  field: {
    fontWeight: props.checked ? 600 : 400,
  },
  root: {
    whiteSpace: 'nowrap',
  },
});

export const options: IChoiceGroupOption[] = [
  {
    key: 'Signing',
    text: 'Active',
    styles: optionStyle,
  },
  {
    key: 'Accounting',
    text: 'Accounting Entry',
    styles: optionStyle,
  },
  {
    key: 'History',
    text: 'History',
    styles: optionStyle,
  },
];
